import React, { Component } from 'react';

import Filterable from '@components/Filterable/Filterable';
import TextStylesList from './TextStylesList';
import { textStylesSet } from './textStylesSet';
import { FILTERS } from './constants';

/*
  Presentational component for Text Styles
*/

class TextStyles extends Component {
  render() {

    return (
      <Filterable
        customClasses={'main-content'}
        filters={FILTERS}
        data={textStylesSet}
        withoutSearch
      >
        <TextStylesList/>
      </Filterable>
    );
  }
}

export default TextStyles;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/TextStyles.js